import { Spin } from "antd"

const Loader = ({ withText = true }) => {
    return (
        <div className="bg-gray-100 flex flex-col justify-center items-center p-6 rounded-md">
            <Spin />
            {withText && <div className="mt-4 text-sm">Data fatching...</div>}
        </div>
    )
}
export default Loader